export default {
  name: 'PAYMENT_MODULE',
  state: {
    paymentLinks: [],
    paymentHistory: [],
    loading: false,
    error: null
  },
  getters: {
    getPaymentLinks: state => state.paymentLinks,
    getPaymentHistory: state => state.paymentHistory,
    isLoading: state => state.loading,
    getError: state => state.error,
    // getApiKey: state => state.apiKey
  },
  mutations: {
    SET_PAYMENT_LINKS(state, links) {
      state.paymentLinks = links;
    },
    SET_PAYMENT_HISTORY(state, history) {
      state.paymentHistory = history;
    },
    SET_LOADING(state, status) {
      state.loading = status;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    CLEAR_ERROR(state) {
      state.error = null;
    }
  },
  actions: {
    async createPaymentLink(context, payload) {
      try {
        context.commit('SET_LOADING', true);
        context.commit('CLEAR_ERROR');

        const apiKey = context.getters.getterApikey;
        const url = `${process.env.VUE_APP_API_BASE_URL}/payments/create-link`;
        payload.store_id = context.getters.getStoreId;
        const response = await axios.post(url, payload, {
          headers: {
            'X-API-KEY': apiKey
          }
        });

        // Add the new payment link to the list
        const links = [...context.state.paymentLinks, response.data];
        context.commit('SET_PAYMENT_LINKS', links);

        return response.data;
      } catch (error) {
        context.commit('SET_ERROR', error.message || 'Failed to create payment link');
        errorHandler.tomcatError(error);
        throw error;
      } finally {
        context.commit('SET_LOADING', false);
      }
    },

    async getPaymentLinks(context) {
      try {
        context.commit('SET_LOADING', true);
        context.commit('CLEAR_ERROR');

        const apiKey = context.getters.getterApikey;
        const url = `${process.env.VUE_APP_API_BASE_URL}/payments/links`;

        const response = await axios.get(url, {
          headers: {
            'X-API-KEY': apiKey
          }
        });

        context.commit('SET_PAYMENT_LINKS', response.data);
        return response.data;
      } catch (error) {
        context.commit('SET_ERROR', error.message || 'Failed to fetch payment links');
        errorHandler.tomcatError(error);
        throw error;
      } finally {
        context.commit('SET_LOADING', false);
      }
    },

    async getPaymentHistory(context) {
      try {
        context.commit('SET_LOADING', true);
        context.commit('CLEAR_ERROR');

        const apiKey = context.getters.getterApikey;
        const url = `${process.env.VUE_APP_API_BASE_URL}/payments/history`;

        const response = await axios.get(url, {
          headers: {
            'X-API-KEY': apiKey
          }
        });

        context.commit('SET_PAYMENT_HISTORY', response.data);
        return response.data;
      } catch (error) {
        context.commit('SET_ERROR', error.message || 'Failed to fetch payment history');
        errorHandler.tomcatError(error);
        throw error;
      } finally {
        context.commit('SET_LOADING', false);
      }
    }
  }
}
